import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import StyledCircularProgress from '../components/StyledCircularProgress';
import useAuth from '../hooks/useAuth';
import AccessDeniedPage from '../pages/generalPages/AccessDeniedPage';

type AuthGuardProps = {
  children: ReactNode;
  requiredPermission?: AuthGuardPermission,
  isSuperAdmin?: boolean
};

type AuthGuardPermission = {
  permission: any,
  permissionType: string
}

export function AuthGuard({ children, requiredPermission, isSuperAdmin }: AuthGuardProps) {
  const { initialized, authenticated, userInformation } = useAuth();
  if (!initialized) {
    return <StyledCircularProgress />;
  }

  if (!authenticated) {
    //Save original url the help oidc redirect logic when coming back from IDM
    localStorage.setItem("originalUrl", location.pathname + location.search);
    return <Navigate to="/login" replace />;
  }

  if (requiredPermission) {
    const permissionsToCheck = userInformation.userPermissions[requiredPermission.permissionType];

    if (!permissionsToCheck) {
      throw new Error(`Invalid permission type. PermissionType: ${requiredPermission.permissionType}`);
    }

    if (!permissionsToCheck.includes(requiredPermission.permission)) {
      return <AccessDeniedPage />;
    }
  }

  if (!requiredPermission && isSuperAdmin === true && !userInformation.isCustomerPortalSuperAdmin) {
    return <AccessDeniedPage />;
  }

  return <>{children}</>;
}